import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_common = `${hostApi}/api/common`

function getFilterList() {
    return Vue.prototype.$http.get(`${api_common}/getFilterList`);
}

function getCodeDictionaryList() {
    return Vue.prototype.$http.get(`${api_common}/getCodeDictionaryList`);
}

// function getRedirectUrl() {
//     return Vue.prototype.$http.get(`${api_common}/getRedirectUrl`);
// }

export {
    api_common,
    getFilterList,
    getCodeDictionaryList,
    // getRedirectUrl,
};
